// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ControlloSaldiDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ControlloSaldiApiClient extends BaseCRUDApiClient<ControlloSaldiDto> {
  // baseUrl = this.config.apiEndpoint + '/piano-conti';
  baseUrl = this.config.apiEndpoint + '/riepilogo-prospetti';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  override getAll() {
    this._pagedCache.clear();
    return this.http.get<ControlloSaldiDto[]>(
      `${this.baseUrl}/controllo-saldi`
    );
  }
}
